import type { BreadcrumbItem } from '@tpct/admin-ui';
import { vsmeMissionsListRelativePath } from '@tpct/mission-core/utils/vsmePortalRoutes';
import BreadcrumbBar from '@tpct/mission-core/components/BreadcrumbBar';
import { __ } from '@/hub-shared/utils/i18n';

type MissionBreadcrumbProps = {
  missionTitle: string;
  onNavigate: (path: string) => void;
};

const MissionBreadcrumb = ({ missionTitle, onNavigate }: MissionBreadcrumbProps) => {
  const items: BreadcrumbItem[] = [
    {
      label: __('Missions VS'),
      onClick: () => onNavigate(vsmeMissionsListRelativePath()),
    },
    { label: missionTitle },
  ];

  return <BreadcrumbBar items={items} />;
};

export default MissionBreadcrumb;
